import type { InterventionJobModulesTableProps } from "./intervention-job-modules-table.type";

import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { JOB_MODULES_SORTS } from "@/entities/job-modules";
import JobModulesTable from "@/modules/job-modules/job-modules-table";
import { ListProvider } from "@/modules/list";

const InterventionJobModulesTable = ({
  intervention,
}: InterventionJobModulesTableProps) => {
  return (
    <ListProvider
      endpoint="interventions.jobModules"
      parentId={intervention.id}
      storageKey={STORAGE_KEYS.JOB_MODULES}
      defaultSort={[JOB_MODULES_SORTS.STARTED_AT_DESC]}
    >
      <JobModulesTable />
    </ListProvider>
  );
};

export default InterventionJobModulesTable;
